class MoveImage {
  constructor(settings) {
    // settings
    this.node = settings.node;
    this.max = settings.max;
    this.min = settings.min;
    this.throttle = settings.throttle;
    this.unit = settings.unit;
    this.changeBy = settings.changeBy;
    this.wrapper = settings.wrapper;

    // setup
    this.wrapperHeight = this.wrapper.offsetHeight;
    this.startPos = (this.node.offsetTop / this.wrapperHeight) * 100;
    this.nodeHeight = this.node.offsetHeight;

    // states
    this.newPos = 0;
    this.currPos = this.startPos;
    this.ticking = false;
    this.lastPos = window.scrollY;
  }

  // move image up
  sub() {
    if (this.currPos >= this.min) {
      this.currPos -= this.changeBy;
    }
  }

  // move image down
  add() {
    if (this.currPos <= this.max) {
      this.currPos += this.changeBy;
    }
  }

  // only move after scrolling [throttle] pixels
  throttleScroll() {
    return (
      this.newPos - this.lastPos < -(this.throttle)
      || this.newPos - this.lastPos > this.throttle
    );
  }

  move() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.newPos = window.scrollY;

        if (this.throttleScroll()) {
          if (this.newPos > this.lastPos) this.sub();
          else this.add();

          this.node.style.top = `${this.currPos}${this.unit}`;
          this.lastPos = window.scrollY;
        }

        this.ticking = false;
      });

      this.ticking = true;
    }
  }
}

export default (settings) => new MoveImage(settings);
